// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as JsBindings from "../../../../../library/JS/JsBindings.bs.js";
import * as PartnerScoreV2CssHelper from "../../../domain/helper/PartnerScoreV2CssHelper.bs.js";

function ScoreSliderValueBoxV2(Props) {
  var current_score = Props.current_score;
  var max_score = Props.max_score;
  var isSuspended = Props.isSuspended;
  var update_value_box_height = Props.update_value_box_height;
  React.useEffect((function () {
          var element = document.getElementById("value-box");
          Curry._1(update_value_box_height, JsBindings.offsetHeight(element));
          
        }), []);
  var match = PartnerScoreV2CssHelper.getSliderBoxStyle(current_score, isSuspended);
  return React.createElement("div", {
              className: "slider-value-box-v2",
              id: "value-box",
              style: {
                backgroundColor: match[1],
                borderColor: match[0],
                left: PartnerScoreV2CssHelper.getSliderBoxPosition(current_score, max_score)
              }
            }, React.createElement("div", {
                  className: "slider-value-v2"
                }, String(current_score) + "%"));
}

var make = ScoreSliderValueBoxV2;

export {
  make ,
  
}
/* react Not a pure module */
